import CircularProgress from "@mui/material/CircularProgress"

export const LoadingSpinner = () => {
  return (
    <CircularProgress data-testid='test' />
  )
}